var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0C13.0093 0 0 13.0093 0 29C0 44.9907 13.0093 58 29 58C44.9907 58 58 44.9907 58 29C58 13.0093 44.9907 0 29 0ZM29 54.6016C14.8832 54.6016 3.39844 43.1168 3.39844 29C3.39844 14.8832 14.8832 3.39844 29 3.39844C43.1168 3.39844 54.6016 14.8832 54.6016 29C54.6016 43.1168 43.1168 54.6016 29 54.6016Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 6.79688C16.7571 6.79688 6.79688 16.7571 6.79688 29C6.79688 41.2429 16.7571 51.2031 29 51.2031C41.2429 51.2031 51.2031 41.2429 51.2031 29C51.2031 16.7571 41.2429 6.79688 29 6.79688ZM29 47.8047C18.631 47.8047 10.1953 39.369 10.1953 29C10.1953 18.631 18.631 10.1953 29 10.1953C39.369 10.1953 47.8047 18.631 47.8047 29C47.8047 39.369 39.369 47.8047 29 47.8047Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0954 19.3075L38.6924 16.9045L29 26.5969L19.3477 16.9446L16.9447 19.3477L26.5969 28.9999L24.1939 31.403L26.5969 33.806L29 31.403L31.403 33.806L33.806 31.403L31.403 28.9999L41.0954 19.3075Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3008 13.5938H30.6992V16.9922H27.3008V13.5938Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3008 41.0078H30.6992V44.4062H27.3008V41.0078Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 27.3008H16.9922V30.6992H13.5938V27.3008Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0078 27.3008H44.4062V30.6992H41.0078V27.3008Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.202d6311.svg";
export { ForwardRef as ReactComponent };